import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Footer } from "./components/navbar/Footer";
import { Home } from "./components/pages/Home";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import { Products } from "./components/pages/Products";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/products" element={<Products />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
